module.exports = "/shiftTasks/index-44e2f7.html";